import { View } from "binder"
import { SingleTransaction } from "../transactionList-viewModel";
import { TransactionDetailViewModel } from "./transactionDetail-viewModel"

export class TransactionDetailView extends View<TransactionDetailViewModel>{
    GetViewUniqueId(): string {
        return "V-E8E2E6B7-92D0-491D-BB02-DD7236DF5144"
    }
    loadHtml(): string {
        let element = require('./transactionDetail.html').default;
        let style = require('./transactionDetail.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set transaction(v: SingleTransaction) { this._transaction = v; } public get transaction(): SingleTransaction { return this._transaction;} private _transaction: SingleTransaction;
    
    closePopup(){
        this.dataContext.closePopup();
    }
}
